<template>
  <div class="disclaimer tw-px-4 tw-pt-12 tw-pb-4 tw-bg-white tw-overflow-auto tw-h-full">
    <div class="disclaimer-container tw-relative tw-h-full">
      <h1 class="title tw-text-black tw-my-0">Disclaimer</h1>
      <p class="message tw-py-6 tw-text-16">
        {{ t('aiaibot_disclaimer-welcome-title') }}
        {{ t('aiaibot_disclaimer-welcome-text') }}
      </p>
      <ExpansionPanels
        :items="[{
          header: t('aiaibot_disclaimer-terms-title'),
          content: t('aiaibot_disclaimer-terms-text'),
        },{
          header: t('aiaibot_disclaimer-privacy-title'),
          content: t('aiaibot_disclaimer-privacy-text'),
        }]"
        @toggleExpander="onToggleExpander"
      />
      <div
        :class="[
          'buttons-container tw-w-full tw-pt-2',
          $mqAliases.isMobile ? 'tw-w-full tw-mt-auto' : aiaiBotBtnsClasses
        ]">
        <ChatButton
          class="sanitas-button accept tw-w-full tw-h-1/2"
          :types="['primary']"
          :label="t('aiaibot_disclaimer-accept-label')"
          @click="acceptDisclaimer()"
        />
        <ChatButton
          class="sanitas-button cancel tw-w-full tw-h-1/2"
          :types="['secondary']"
          :label="t('aiaibot_disclaimer-cancel-label')"
          @click="cancelDisclaimer()"
        />
        <p class="cancel-info tw-px-4 tw-py-2 tw-font-size-small">
          {{ t('aiaibot_disclaimer-cancel-info-text') }}
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import { useI36n } from '@jota-one/i36n/src/index.vue2'
import { trigger, triggerType } from '@/helpers/Tracker'
import store from '@/store'
import ChatButton from '@/components/ChatButton'
import ExpansionPanels from '@/components/ExpansionPanels'

export default {
  name: 'AiaiBotDisclaimer',
  components: {
    ChatButton,
    ExpansionPanels
  },
  setup () {
    const { $label: t } = useI36n()
    const aiaiBotBtnsClasses = ref('')

    aiaiBotBtnsClasses.value = getChatButtonsPositionClasses()

    function onToggleExpander (isExpanded) {
      aiaiBotBtnsClasses.value = isExpanded ? '' : getChatButtonsPositionClasses()
    }

    function getChatButtonsPositionClasses () {
      let expandedElements = document.getElementsByClassName('fa-angle-up')
      let hasExpandedPanels = expandedElements && expandedElements.length > 1
      return hasExpandedPanels ? '' : 'tw-absolute tw-bottom-0'
    }

    const acceptDisclaimer = async () => {
      trigger(triggerType.ACTION, 'ChatBotDisclaimerAccepted')
      await store.dispatch('uistate/acceptAiaiBotDisclaimer')
      store.dispatch('conversation/connect', {}, { root: true })
    }

    function cancelDisclaimer () {
      trigger(triggerType.ACTION, 'ChatBotDisclaimerRefused')
      store.dispatch('uistate/refuseAiaiBotDisclaimer')
    }

    return {
      t,
      aiaiBotBtnsClasses,
      onToggleExpander,
      acceptDisclaimer,
      cancelDisclaimer
    }
  }
}
</script>

<style scoped lang="postcss">
.disclaimer {
  &-container {
    .title {
      font-size: 25px;
    }
    .message {
      @apply tw-text-black;
    }
    .buttons-container {
      .sanitas-button {
        height: 50px;
        border-radis: 25px;
      }
    }
  }
}

.cancel-info {
  font-size: var(--tw-font-size-xsmall);
}
</style>
